export default __webpack_public_path__ + "static/pic8-aaf41d89a38c277c39bec8805c9fb635.jpg";